module.exports = __webpack_public_path__ + "media/images/onboarding1-93630804.png";